import { registrationConstants } from '../constants';

export function registrationReducers(state = {}, action) {
    switch (action.type) {
            
        // Get Client List
        
        case registrationConstants.getClientList_request:
            return {
                ...state,
                getClientList_requesting: true, getClientList_status: false,
            }
        case registrationConstants.getClientList_success:
            return {
                ...state,
                getClientList_requesting: false, getClientList_status: true,
                clientList: action.details.data,
                clientListHeader: action.details.headers, 
            }
        case registrationConstants.getClientList_failure:
            return {
                ...state,
                getClientList_requesting: false, getClientList_status: false, 
            }

        // Add Client
        
        case registrationConstants.addClient_request:
            return {
                ...state,
                addClient_requesting: true, addClient_status: false,
            }
        case registrationConstants.addClient_success:
            return {
                ...state,
                addClient_requesting: false, addClient_status: true,
            }
        case registrationConstants.addClient_failure:
            return {
                ...state,
                addClient_requesting: false, addClient_status: false, 
            }

        // Update Client
        
        case registrationConstants.updateClient_request:
            return {
                ...state,
                updateClient_requesting: true, updateClient_status: false,
            }
        case registrationConstants.updateClient_success:
            return {
                ...state,
                updateClient_requesting: false, updateClient_status: true,
            }
        case registrationConstants.updateClient_failure:
            return {
                ...state,
                updateClient_requesting: false, updateClient_status: false, 
            }

        // Delete Client
        
        case registrationConstants.deleteClient_request:
            return {
                ...state,
                deleteClient_requesting: true, deleteClient_status: false,
            }
        case registrationConstants.deleteClient_success:
            return {
                ...state,
                deleteClient_requesting: false, deleteClient_status: true,
            }
        case registrationConstants.deleteClient_failure:
            return {
                ...state,
                deleteClient_requesting: false, deleteClient_status: false, 
            }

        default:
            return state;
    }
}